// utils/geolocation.ts
import i18next from "i18next";

export const fetchAddressFromCoords = async (
  lat: number,
  lng: number
): Promise<string> => {
  try {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=${i18next.language}&key=AIzaSyCs0NsympWsz3Lbxc7P3_pQTJZGjlbo0Ko`
    );
    const data = await response.json();
    if (data.results && data.results[0]) {
      return data.results[0].formatted_address;
    } else {
      return "Address not found";
    }
  } catch (error) {
    console.error(error);
    return "Error fetching address"; // default fallback
  }
};
